module.exports = __webpack_public_path__ + "img/sixpackcarrier23.488edc9e.jpg";